import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AdditionOfManpowerService } from '../../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { DesignationWiseSummaryComponent } from '../../designation-wise-summary/designation-wise-summary.component';
import { Router } from '@angular/router';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';

@Component({
  selector: 'app-site-wise-manpower-summary-new',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgbDropdownModule, NgSelectModule, NgbDatepickerModule, DataTablesModule, NgbTooltip],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './site-wise-manpower-summary-new.component.html',
  styleUrl: './site-wise-manpower-summary-new.component.scss'
})
export class SiteWiseManpowerSummaryNewComponent {
  isDisabled: boolean = false;

  Regions: any[] = [];
  Branchs: any[] = [];
  Zones: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  Supervisors: any[] = [];

  SiteData: any[] = [];
  public User: any = null;
  Filter = {
    RegionID: [],
    BranchID: [],
    ZoneID: [],
    ClientID: [],
    SiteID: [],
    SiteOwnerID: [],
    Date: null as any,
    TotalCount: 0,
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private utility: UtilityService,
    private siteadditionreduction: AdditionOfManpowerService,
    private dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private router: Router,
    protected common: CommonService,
    private sessionService: SessionService,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
    this.ComboLoad2('Region');
    this.ComboLoad2('Branch');
    this.ComboLoad2('Zone');
    this.ComboLoad2('Client');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_SiteManpowerSummary('S');
    } else {
      form.submitted = true;
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.Date = this.dateFormate.parse(response.Table[0].RegistrationDate)
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad2(Combotype: String) {
    this.isDisabled = true;

    // if (Combotype == 'Branch') {
    //   this.Branchs = [];
    //   this.Zones = [];
    //   this.Clients = [];
    //   this.Sites = [];
    //   this.Supervisors = [];


    //   this.Filter.BranchID = [];
    //   this.Filter.ZoneID = [];
    //   this.Filter.ClientID = [];
    //   this.Filter.SiteID = [];
    //   this.Filter.SiteOwnerID = [];
    // } else if (Combotype == 'Zone') {
    //   this.Zones = [];
    //   this.Clients = [];
    //   this.Sites = [];
    //   this.Supervisors = [];

    //   this.Filter.ZoneID = [];
    //   this.Filter.ClientID = [];
    //   this.Filter.SiteID = [];
    //   this.Filter.SiteOwnerID = [];
    // } else if (Combotype == 'Client') {
    //   this.Clients = [];
    //   this.Sites = [];
    //   this.Supervisors = [];

    //   this.Filter.ClientID = [];
    //   this.Filter.SiteID = [];
    //   this.Filter.SiteOwnerID = [];
    // } else if (Combotype == 'Site') {
    //   this.Sites = [];
    //   this.Zones = [];
    //   this.Supervisors = [];

    //   this.Filter.SiteID = [];
    //   this.Filter.SiteOwnerID = [];
    // } else if (Combotype == 'SiteOwner') {
    //   this.Supervisors = [];

    //   this.Filter.SiteOwnerID = [];
    // }

    if (true || (Combotype == 'Region') ||
      (Combotype == 'Branch' && this.Filter.RegionID.length > 0) ||
      (Combotype == 'Zone' && this.Filter.BranchID.length > 0) ||
      (Combotype == 'Client' && this.Filter.ZoneID.length > 0) ||
      (Combotype == 'Site' && this.Filter.ClientID.length > 0) ||
      (Combotype == 'SiteOwner' && this.Filter.SiteID.length > 0)) {
      this.siteadditionreduction.ComboLoad({
        'SelectType': Combotype,
        'RegionId': this.Filter.RegionID.toString(),
        'BranchId': this.Filter.BranchID.toString(),
        'ZoneId': this.Filter.ZoneID.toString(),
        'ClientId': this.Filter.ClientID.toString(),
        'SiteId': this.Filter.SiteID.toString(),
        'SupervisorId': this.Filter.SiteOwnerID.toString(),
      }).subscribe({
        next: (response) => {
          if (Combotype == 'Branch') {
            this.Branchs = response.Table;
          } else if (Combotype == 'Client') {
            this.Clients = response.Table;
          } else if (Combotype == 'Site') {
            this.Sites = response.Table;
          } else if (Combotype == 'Region') {
            this.Regions = response.Table;
          } else if (Combotype == 'Zone') {
            this.Zones = response.Table;
          } else if (Combotype == 'SiteOwner') {
            this.Supervisors = response.Table;
          }
          this.isDisabled = false;
        },
        complete: () => {
        },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.isDisabled = false;
    }
  }


  ESS_SiteManpowerSummary(Type: String) {
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerSummary({ SelectType: Type, RegionId: this.Filter.RegionID.toString(), BranchId: this.Filter.BranchID.toString(), ZoneId: this.Filter.ZoneID.toString(), ClientId: this.Filter.ClientID.toString(), SiteId: this.Filter.SiteID.toString(), SupervisorId: this.Filter.SiteOwnerID.toString(), AsOnDate: this.dateFormate.format(this.Filter.Date), UserId: this.User.UserId }).subscribe({
      next: (response) => {
        if (Type == 'S') {
          this.SiteData = Object.values(response.Table)
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.ESS_SiteManpowerSummary('Count');
        } else if (Type == 'Count') {
          this.Filter.TotalCount = response.Table[0].NoOfPerson;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }


  OpenDesignationSummary(element: any) {
    if (this.common.PageRight.IsView) {
      const modalRef = this.modalService.open(DesignationWiseSummaryComponent, { centered: true, backdrop: 'static', size: 'xl' });
      modalRef.componentInstance.InputData = {
        SelectType: 'D',
        RegionId: this.Filter.RegionID.toString(),
        BranchId: element.BranchMasterId,
        ZoneId: this.Filter.ZoneID.toString(),
        ClientId: element.ClientGroupMasterId,
        SiteId: element.SiteMasterId,
        SupervisorId: this.Filter.SiteOwnerID.toString(),
        AsOnDate: this.dateFormate.format(this.Filter.Date),
      };
    }
  }

  Detail(element: any) {
    if (this.common.PageRight.IsView) {
      this.router.navigate(['master/ViewAllocateManpowerNew/' + element.BranchMasterId + "/" + element.ClientGroupMasterId + "/" + element.SiteMasterId]);
      //this.router.navigate(['master/AdditionOfManpower'], {queryParams: {siteMode: true,bid: element.BranchMasterId,cid: element.ClientGroupMasterId,sid: element.SiteMasterId,Date: this.dateFormate.format(this.Filter.Date)}});
    }
  }

  Addition(element: any) {
    if (this.common.PageRight.IsAdd) {
      this.router.navigate(['master/AdditionOfManpowerNew/0/s/' + element.BranchMasterId + "/" + element.ClientGroupMasterId + "/" + element.SiteMasterId]);
      //this.router.navigate(['master/AdditionOfManpower'], {queryParams: {siteMode: true,bid: element.BranchMasterId,cid: element.ClientGroupMasterId,sid: element.SiteMasterId,Date: this.dateFormate.format(this.Filter.Date)}});
    }
  }

  Reduction(element: any) {
    if (this.common.PageRight.IsAdd) {
      this.router.navigate(['master/ReductionOfManpowerNew/0/s/' + element.BranchMasterId + "/" + element.ClientGroupMasterId + "/" + element.SiteMasterId]);
      //this.router.navigate(['master/AdditionOfManpower'], {queryParams: {siteMode: true,bid: element.BranchMasterId,cid: element.ClientGroupMasterId,sid: element.SiteMasterId,Date: this.dateFormate.format(this.Filter.Date)}});
    }
  }

  onchange() {
    this.SiteData = []
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}

